module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<h1><%= model.headline %></h1>\n<% if(!utils.isEmpty(model.content)){ %>\n<p class=\"content\"><%= model.content %></p>\n<% } %>\n<%- model.html || '' %>\n<%\nif(!utils.isEmpty(model.image)){\nvar imageList = helpers.detectRenderedImages(model.image, model._image);\nutils.forEach(imageList, function(image){\nvar renderedImage = (image.rendered || {}).preview || {};\n%>\n<img class=\"<%- renderedImage.class %>\" src=\"<%- renderedImage.url %>\" width=\"<%- renderedImage.width %>\" height=\"<%- renderedImage.height %>\" alt=\"<%= renderedImage.alt %>\" title=\"<%= renderedImage.title %>\" style=\"max-width: 500px; height: auto;\" />\n<%\n});\n}\nif(!utils.isEmpty(model.file)){\n%>\n<ul>\n<%\nutils.forEach(model.file, function(file){\n%>\n<li><a href=\"<%= file.url %>\" alt=\"<%= file.alt %>\" title=\"<%= file.title %>\"><%= file.name %></a></li>\n<%\n});\n%>\n</ul>\n<%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/dummy/dummy.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<h1>")
    ; __line = 2
    ; __append(escapeFn( model.headline ))
    ; __append("</h1>\n")
    ; __line = 3
    ;  if(!utils.isEmpty(model.content)){ 
    ; __append("\n<p class=\"content\">")
    ; __line = 4
    ; __append(escapeFn( model.content ))
    ; __append("</p>\n")
    ; __line = 5
    ;  } 
    ; __append("\n")
    ; __line = 6
    ; __append( model.html || '' )
    ; __append("\n")
    ; __line = 7
    ; 
if(!utils.isEmpty(model.image)){
var imageList = helpers.detectRenderedImages(model.image, model._image);
utils.forEach(imageList, function(image){
var renderedImage = (image.rendered || {}).preview || {};

    ; __line = 12
    ; __append("\n<img class=\"")
    ; __line = 13
    ; __append( renderedImage.class )
    ; __append("\" src=\"")
    ; __append( renderedImage.url )
    ; __append("\" width=\"")
    ; __append( renderedImage.width )
    ; __append("\" height=\"")
    ; __append( renderedImage.height )
    ; __append("\" alt=\"")
    ; __append(escapeFn( renderedImage.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( renderedImage.title ))
    ; __append("\" style=\"max-width: 500px; height: auto;\" />\n")
    ; __line = 14
    ; 
});
}
if(!utils.isEmpty(model.file)){

    ; __line = 18
    ; __append("\n<ul>\n")
    ; __line = 20
    ; 
utils.forEach(model.file, function(file){

    ; __line = 22
    ; __append("\n<li><a href=\"")
    ; __line = 23
    ; __append(escapeFn( file.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( file.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( file.title ))
    ; __append("\">")
    ; __append(escapeFn( file.name ))
    ; __append("</a></li>\n")
    ; __line = 24
    ; 
});

    ; __line = 26
    ; __append("\n</ul>\n")
    ; __line = 28
    ; 
}

    ; __line = 30
    ; __append("\n</div>")
    ; __line = 31
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/dummy/dummy.ejs

}